<template>
  <div id="removeclass">
    <app-modal
      :modal-id="modalId"
      :preloader="preloader"
      @close-modal="closeModal"
    >
      <template slot="header"> 
        <h5>{{modalTitle}}</h5>
      </template>
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <el-form v-if="active === 1"> 
          <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="addUrl">
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("title") }}
              </label>
              <app-input
                id="inputs_name"
                class="col-sm-9"
                type="text"
                v-model="inputs.name"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("description") }}
              </label>
              <app-input
                id="inputs_email"
                class="col-sm-9"
                type="textarea"
                v-model="inputs.description"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <div class="col-sm-3 mb-3">
                <label for="inputs_category" >
                  {{ $t("category") }}
                </label>
              </div>
              <div class="col-sm-9">
                <app-input
                  id="inputs_category"
                  type="search-select"
                  :placeholder="$t('select_category')"
                  v-model="inputs.business_category_id"
                  :list="category"
                />
                <p class="font-italic text-muted">
                  {{ $t("shortcut_category_create") }} <span><a href="#" @click.prevent="addCategory()">{{$t("add_category")}}</a></span>
                </p>
              </div>
            </div>
            <!-- <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("is_parent") }}
              </label>
              <app-input
                class="mt-2 pt-1 col-sm-9"
                type="radio"
                :list="parentradio"
                v-model="inputs.is_parent"
                :required="true"
              />
            </div>  -->
           <!-- <div
              class="form-group row align-items-center"
              v-if="inputs.is_parent != 1"
            >
              <label for="inputs_status" class="col-sm-3 mb-0">
                {{ $t("parent") }}
              </label>
              <app-input
                class="col-sm-9"
                :list="this.parentList"
                type="search-select"
                :placeholder="$t('select_parent')"
                v-model="inputs.select_parent"
              />
            </div> -->
            <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("is_public") }}
              </label>
              <app-input
                class="mt-2 pt-1 col-sm-9"
                type="radio"
                :list="publicradio"
                v-model="inputs.is_public"
                :required="true"
              />
            </div>
          </form>
        </el-form>
        <el-form v-if="active === 2"> 
         <documentlibrary-add-category :back='closeCategory'></documentlibrary-add-category>
        </el-form>
      </template>
      <template slot="footer" v-if="active == 1">
        <div class="row mt-2 text-right" >
          <div class="col-md-12">
              <button class="btn btn-secondary" @click="closeModal()">{{$t('cancel')}}</button>
              <button class="btn btn-primary" @click.prevent="submit()">{{$t('save')}}</button>
          </div>
        </div>
      </template>
    </app-modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import * as actions from "../../../../Config/ApiUrl";
// import {  } from "../../../../Helpers/AxiosHelper";
// import ThemeMixin from "../../../../../core/mixins/global/ThemeMixin";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    refresh: Function,
    type: String,
    selectedId: Number,
  },
  data() {
    return {
      addUrl: actions.FORMS_POST,
      active: 1,
      category: [],
      parentradio: [
        { id: "1", value: "Yes" },
        { id: "0", value: "No" },
      ],
      publicradio: [
        { id: "1", value: "Yes" },
        { id: "0", value: "No" },
      ],
      preloader: false,
      inputs: {
        yes: "no",
      },
      parentList: [],
      modalId: "demo-add-edit-folder-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
    else {
      this.inputs = {};
    }
    if(this.selectedId){
      this.parent_id = this.selectedId;
    }
    this.getCategories();
  },
  methods: {
    addCategory() {
      this.active = 2;
    },
    closeCategory(value) {
      this.active = value;
      this.getCategories();
    },
    getCategories() {
      axiosGet(actions.CATEGORIES)
        .then((res) => {
          this.category = res.data;
        })
        .catch((error) => {
          
        });
    },
    submit() {
      this.inputs.type = this.type;
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        let split = this.selectedUrl.split("/");
        this.inputs.task_id = split[6];
        axiosPost(actions.FORMS_UPDATE, this.inputs)
          .then((res) => {
            this.$toastr.s(res.data.type);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.refresh();
          });
      } else {
        this.inputs.is_parent = 1;
        this.inputs.parent_id = this.selectedId;
        this.inputs.is_file_folder = 'folder';
        this.save(this.inputs);

      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.refresh();
    },

    afterSuccessFromGetEditData(response) {
      //   if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
    getparent() {
      axiosGet(actions.FORMS_GET_PARENT)
        .then((res) => {
          this.parentList = res.data;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    this.getparent();
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
  },
};
</script>
